export const Img = ({ name, alt, className = "", eager = false, sizes = "(min-width: 1024px) 50vw, 100vw", style }) => (
  <img
    src={`/images/${name}.webp`}
    srcSet={`/images/${name}-sm.webp 720w, /images/${name}.webp 1400w`}
    sizes={sizes}
    alt={alt}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    className={className}
    style={style}
  />
);
